import { render } from "./NotFound.vue?vue&type=template&id=e6d48b38&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=e6d48b38&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6d48b38"]])

export default __exports__